import React from 'react';

import { EmploymentPageStore } from 'app/logic/pages/employment/EmploymentPageStore';
import { Section } from 'app/component/Section';
import { JobDetailsForm } from 'app/logic/pages/employment/JobDetailsForm';

export interface JobDetailsFormSectionProps {
    pageStore: EmploymentPageStore;
}

export const JobDetailsFormSection = ({
    pageStore,
}: JobDetailsFormSectionProps) => {
    return (
        <Section
            className={'jobDetailsFormSection'}
            title={'Дополнительные сведения'}
            content={<JobDetailsForm formStore={pageStore.formStore} />}
        />
    );
};
